import React from "react";
import { Grid, GridItem, Stack, SimpleGrid, Box, Divider } from "@chakra-ui/react";
import FooterBranding from "./components/footerBranding";
import FooterIaasServices from "./components/footerIaasServices";
import FooterGeneralPolicies from "./components/footerGeneralPolicies";
import FooterServersPolicies from "./components/footerServerPolicies";
import FooterService from "./components/footerServices";
import FooterSocial from "./components/footerSocial";
import FooterSupport from "./components/footerSupport";
import dynamic from "next/dynamic";

const SafeView = dynamic(() => import("@/components/safeView"));

function Footer() {
  return (
    <Box backgroundColor="primary.200" paddingTop={{ base: 0, md: "3.5rem" }}>
      <Stack>
        <SafeView>
          <Grid gap={4} py={{ base: 3, sm: 6 }} templateColumns={"repeat(4,1fr)"}>
            <GridItem colSpan={{ base: 4, md: 1 }}>
              <FooterBranding />
            </GridItem>
            <GridItem colSpan={{ base: 4, md: 3 }}>
              <SimpleGrid
                columns={{ base: 1, sm: 2, md: 3, "2xl": 5 }}
                spacing={{ base: 6, lg: 12, "2xl": 6 }}
              >
                <FooterService />
                <FooterIaasServices />
                <FooterSupport />
                <FooterGeneralPolicies />
                <FooterServersPolicies />
              </SimpleGrid>
            </GridItem>
          </Grid>
        </SafeView>
        <Divider color="#ababab" />
        <FooterSocial />
      </Stack>
    </Box>
  );
}

export default Footer;
